import { render } from "./HeadlinesAction.vue?vue&type=template&id=26ae533e"
import script from "./HeadlinesAction.vue?vue&type=script&lang=js"
export * from "./HeadlinesAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__